import React, { useEffect, useRef, useState } from "react";
import { ActivityIndicator, Dimensions, TouchableOpacity, View } from "react-native";
import BottomSheet from "./BottomSheet";
import { ModalAlignmentEnum } from "@voltmoney/types";
import { isMobile } from "../stack/utils";
import { getScreenType } from "./utils";
import { OtpInput } from "./OtpInput/OtpInput";
import { ColorTokens, FontFamilyTokens, FontSizeTokens, InputStateToken, TypographyTypeDLS } from "@voltmoney/schema";
import Typography from "../typography/Typography";
import * as Animatable from 'react-native-animatable';
import EmailSubtitle from "../emailSubtitle/EmailSubtitle";
import BottomSheetMf, { BottomSheetAnimation } from "../bottomSheetMF/bottomSheetMf";
const OtpModalScreenDc = ({ id, showOtpModal, setShowOtpModal, charLimit = 6, resendTimer = 15, action, isDarkMode, triggerAction, onChangeText, state = InputStateToken.DEFAULT, otpAction, handleCloseOtpModal, caption, extraSpace, title, subTitle, value, iconUrl, useNewBottomSheet = false }) => {
    const [inputValue, setInputValue] = useState("");
    const [isLoading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [modalHeight, setModalHeight] = useState(340);
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const inputRef = useRef(null);
    const [otpLimitExceeded, setOtpLimitExceeded] = useState(false);
    const [isErrorState, setIsErrorState] = useState(false);
    const [isSuccessState, setIsSuccessState] = useState(false);
    const [showTimer, setShowTimer] = useState(false);
    const [seconds, setSeconds] = useState(resendTimer);
    const [isRunning, setIsRunning] = useState(false);
    const [successText, setSuccessText] = useState(false);
    const [loader, setLoader] = useState(false);
    const [btnLoader, setbtnLoader] = useState(false);
    const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    useEffect(() => {
        setIsRunning(true);
    }, []);
    useEffect(() => {
        if (successText) {
            setTimeout(() => {
                setSuccessText(false);
            }, 3000);
        }
    }, [showTimer, seconds]);
    useEffect(() => {
        let timer;
        if (isRunning && seconds > 0) {
            timer = setInterval(() => {
                setSeconds((prevSeconds) => prevSeconds - 1);
            }, 1000);
        }
        else if (seconds === 0) {
            setIsRunning(false);
        }
        return () => clearInterval(timer);
    }, [isRunning, seconds]);
    useEffect(() => {
        if (state === 'SUCCESS')
            setIsSuccessState(true);
        else if (state === 'ERROR') {
            setIsErrorState(true);
            setLoader(false);
        }
        else if (state === 'DISABLED')
            setOtpLimitExceeded(true);
        else {
            setIsErrorState(false);
            setOtpLimitExceeded(false);
        }
    }, [state]);
    const handleReset = () => {
        setSeconds(resendTimer);
        setIsRunning(true);
        setLoader(false);
        setIsErrorState(false);
        setIsSuccessState(true);
    };
    const returnOtpModal = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: useNewBottomSheet ? 0 : 16, zIndex: 1, flex: 1 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, label: title, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night }),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(EmailSubtitle, { label: subTitle, subLabel: value, iconUrl: iconUrl, iconName: undefined, isDarkMode: isDarkMode ? true : false })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(OtpInput, { numberOfDigits: charLimit, ref: inputRef, editable: !btnLoader && !otpLimitExceeded, isDarkMode: isDarkMode ? true : false, onTextChange: async (text) => {
                        if (onChangeText) {
                            onChangeText(text);
                        }
                        if (text.length === charLimit && text[text.length - 1] >= '0' && text[text.length - 1] <= '9') {
                            if (action && triggerAction && !otpLimitExceeded) {
                                setbtnLoader(true);
                                setIsErrorState(false);
                                await action(text);
                                setbtnLoader(false);
                            }
                        }
                        else {
                            setIsErrorState(false);
                            setLoader(false);
                        }
                    }, focusColor: isErrorState ? 'red' : 'blue', theme: {
                        inputsContainerStyle: {
                            width: 47,
                            height: 47,
                            borderRadius: 0,
                        },
                        pinCodeContainerStyle: { borderRadius: 8, borderColor: isDarkMode ? 'white' : '#DFDFDE' },
                        pinCodeTextStyle: isDarkMode ? { fontSize: 15, color: 'white' } : { fontSize: 15 },
                        containerStyle: { width: 310 },
                    } }),
                React.createElement(View, { style: { marginTop: 18 } }),
                btnLoader && !isErrorState && !otpLimitExceeded && (React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(ActivityIndicator, { color: "#1434CB", size: "small" }),
                    React.createElement(View, { style: { marginLeft: 6 } },
                        React.createElement(Typography, { label: "Verifying OTP", fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Primary_100, lineHeight: 20, fontFamily: FontFamilyTokens.Inter })))),
                btnLoader || (!isErrorState && !otpLimitExceeded) && (React.createElement(View, { style: { height: extraSpace } })),
                isErrorState && inputRef?.current?.clear(),
                (isErrorState || otpLimitExceeded) && (React.createElement(View, { style: {} },
                    React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
                        React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.System_Error, label: caption?.error ? caption?.error : "" })))),
                isSuccessState && (React.createElement(View, { style: {} },
                    React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
                        React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.Success_100, label: caption?.success ? caption?.success : "" })))),
                React.createElement(View, { style: {
                        paddingTop: 18,
                        flexDirection: 'row',
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal, label: "Didn't receive OTP?" })),
                    React.createElement(TouchableOpacity, { disabled: otpLimitExceeded, style: { marginLeft: 8 }, onPress: async () => {
                            if ((seconds === 0 && !otpLimitExceeded)) {
                                setSuccessText(true);
                                setShowTimer(false);
                                handleReset();
                                //@ts-ignore
                                inputRef?.current?.clear();
                                if (otpAction) {
                                    await otpAction();
                                }
                            }
                            else
                                setShowTimer(true);
                        } },
                        React.createElement(Typography, { id: 'txt_emailScreen_resendOtp', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, color: seconds === 0 && !otpLimitExceeded
                                ? ColorTokens.Primary_100
                                : isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal, label: 'Resend OTP' }))),
                !successText && showTimer && seconds > 0 && (React.createElement(View, { style: { marginTop: 10 } },
                    React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
                        React.createElement(Typography, { label: `Please wait for ${seconds}s to resend OTP`, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, lineHeight: 20, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night })))),
                successText &&
                    React.createElement(View, { style: { marginTop: 10 } },
                        React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
                            React.createElement(Typography, { label: `OTP has been resent.`, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, lineHeight: 20, color: ColorTokens.Secondary_100 }))))));
    };
    if (useNewBottomSheet) {
        return React.createElement(React.Fragment, null,
            React.createElement(BottomSheetMf, { modalVisible: showOtpModal, onModalClose: async () => {
                    setShowOtpModal(false);
                    if (handleCloseOtpModal) {
                        await handleCloseOtpModal();
                    }
                }, animationType: BottomSheetAnimation.NONE, onModalOpen: () => setShowOtpModal(true), showClose: true, onClosePress: async () => {
                    setShowOtpModal(false);
                    if (handleCloseOtpModal) {
                        await handleCloseOtpModal();
                    }
                } }, returnOtpModal()));
    }
    return showOtpModal ? (React.createElement(View, { style: {
            position: 'absolute',
            bottom: 0,
            zIndex: 99
        } },
        React.createElement(BottomSheet, { autoAdjustHeight: false, height: modalHeight, width: '100%', closeFunction: async () => {
                setShowOtpModal(false);
                if (handleCloseOtpModal)
                    await handleCloseOtpModal();
            }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: Dimensions.get('window').height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true, explicitMarginBottom: 0 }, returnOtpModal()))) : React.createElement(React.Fragment, null);
};
export default OtpModalScreenDc;
